module.exports = __webpack_public_path__ + "img/plain-loader.3463716f.gif";